

<template>
  <Transition name="scroll-y-reverse-transition" mode="out-in">
    <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

    <v-container class="text--white" dark id="home-container">
      <v-row class="links-container text-center mt-3">
        <v-col cols="12">
          <v-img
            max-width="250"
            height="250"
            contain
            src="../images/blackwhite_badge_supermin4.png"
            class="mx-auto"
          ></v-img>
        </v-col>
        <v-col cols="12">
          <h1>RPD EverWatch</h1>
        </v-col>
        <v-col cols="12">
          <v-btn
            color="secondary"
            class="black--text link-button mx-auto"
            large
            @click="goToURL('logs')"
          >
            LOGS
          </v-btn>
        </v-col>
        <!-- <v-col cols="12">
          <v-btn
            color="secondary"
            class="black--text link-button mx-auto"
            large
            href="/atls"
          >
            ATLS
          </v-btn>
        </v-col> -->
      </v-row>
    </v-container>
  </Transition>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

#home-container {
  max-width: 1068px;
  height: auto;
  padding: 0px;
}

.fab-container {
  position: fixed;
  bottom: 0;
  right: 0;
}

.links-container {
  align-items: center;
}

.link-button {
  width: 60%;
  font-size: 1.1rem;
}

@media only screen and (max-width: 600px) {
  .link-button {
    font-size: 1.1rem;
    width: 80%;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "Home",
  mixins: [bus_common],
  components: {},
  data() {
    return {};
  },
  watch: {
    "$store.state.user.email": function () {
      let self = this;
      if (this.$store.state.user.email.length > 0) {
        /*this.init()*/
      }
    },
  },
  methods: {
    // Init / General
    init() {},

    goToURL(url) {
      var qry_token = this.$route.query.token;
      this.$router.push({ path: url, query: { token: qry_token } });
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
